import React from 'react';
import { Box, makeStyles, Table, TableBody, TableCell, TableRow } from '@material-ui/core';

import { TableHeader } from 'components/Widgets/Tables/common/components';

import { getCellFormat, HOLDING_INVESTOR_PERFORMANCE_GROUP_SHAPE } from '../utils';
import columns from '../content';

const useStyles = makeStyles(theme => ({
  header: {
    backgroundColor: theme.palette.primary.dark,
    padding: '.25rem',
    color: theme.palette.white,
    fontWeight: theme.typography.fontWeightBold
  },
  row: {
    '& td': {
      fontSize: theme.customStyles.tableRow.fontSize,
      padding: '.5rem',
      '&:not(last-child)': {
        borderLeft: `1px solid ${theme.palette.grey.medium}`
      }
    }
  },
  totalRow: {
    backgroundColor: theme.palette.grey.light
  },
  totalRowCell: {
    fontSize: theme.customStyles.tableRow.fontSize,
    color: theme.palette.primary.main,
    fontWeight: 'bold'
  },
  cell: {
    color: theme.palette.grey.dark
  },
  portfolio: {
    fontWeight: 'bold',
    color: theme.palette.black
  },
  negative: {
    color: theme.palette.error.main
  }
}));

const HoldingTable = ({ holdingName, groupData, groupTotals }) => {
  const classes = useStyles();

  const renderRow = (row, isTotalRow = false) =>
    columns.map(column => {
      const { value, classList } = getCellFormat(column.key, row[column.key], isTotalRow);
      return (
        <TableCell key={`${column.key}-${row.portfolio}`}>
          <span className={classList.map(c => classes[c]).join(' ')}>{value}</span>
        </TableCell>
      );
    });

  const renderBody = () =>
    groupData.map(groupRow => (
      <TableRow key={`${holdingName}-${groupRow.portfolio}`} className={classes.row}>
        {renderRow(groupRow)}
      </TableRow>
    ));

  const renderTotalRow = () => (
    <TableRow className={`${classes.row} ${classes.totalRow}`}>
      {renderRow({ ...groupTotals, portfolio: 'Total' }, true)}
    </TableRow>
  );

  return (
    <>
      <Box className={classes.header}>{holdingName}</Box>
      <Table>
        <TableHeader
          columns={columns}
          showHeaderBorder={false}
          firstColumnFixedWidth={90}
          columnFixedWidth={150}
        />
        <TableBody>
          {renderBody()}
          {groupTotals && renderTotalRow()}
        </TableBody>
      </Table>
    </>
  );
};

HoldingTable.propTypes = HOLDING_INVESTOR_PERFORMANCE_GROUP_SHAPE;

export default HoldingTable;
